import { HTTP_TOKEN } from "./http";

export const createSessionStripe = data => {
  return HTTP_TOKEN.post("subscription/generate_url_stripe", data).then(result => {
    return result.data;
  });
};
